import React from 'react';
import { Helmet } from 'react-helmet-async';

const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <Helmet>
        <title>Page Not Found — HICO</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 className="pageTitle">404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
